// Light / dark / system theme. The choice is a per-viewer convenience in
// localStorage; CSS tokens switch on `html[data-theme]` or the OS preference.
import { readLocal, STORAGE_KEYS, writeLocal } from './storage';

export type ThemeChoice = 'system' | 'light' | 'dark';

export function storedTheme(): ThemeChoice {
  const v = readLocal(STORAGE_KEYS.theme);
  return v === 'light' || v === 'dark' ? v : 'system';
}

export function applyTheme(choice: ThemeChoice): void {
  const html = document.documentElement;
  if (choice === 'system') html.removeAttribute('data-theme');
  else html.setAttribute('data-theme', choice);
  writeLocal(STORAGE_KEYS.theme, choice === 'system' ? null : choice);
}

export function applyStoredTheme(): void {
  const c = storedTheme();
  if (c !== 'system') document.documentElement.setAttribute('data-theme', c);
}

export function nextTheme(c: ThemeChoice): ThemeChoice {
  return c === 'system' ? 'light' : c === 'light' ? 'dark' : 'system';
}
